module.exports = __webpack_public_path__ + "static/media/BO.f74006fc.png";